import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { StickyBar as StickyBarCotopaxi, useScrollPosition, Carousel, CarouselVariant, Column, SliderNavColor, SliderNavVariant, StickyBarVariant, } from '@as/cotopaxi';
import { MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_DESKTOP, MIN_SCREEN_WIDTH_DESKTOP_LARGE, } from '../../../constants/ScreenWidthConstants';
import { SLIDE_SPACING, SLIDES_AMOUNT_DESKTOP, SLIDES_AMOUNT_DESKTOP_LARGE } from '../../../constants/SliderConstants';
import { NAVIGATION_HORIZONTAL, NAVIGATION_HORIZONTAL_COLLAPSE } from '../../../constants/DOMElementsConstants';
import { DELAY } from '../../../constants/GeneralConstants';
import { CompareStickyBarSlide } from './CompareStickyBarSlide';
import { Container, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
const COMPARE_STICKY_POSITION_DESKTOP = 700;
export const CompareStickyBar = ({ comparisonProducts, setSwiperInstance, }) => {
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const [hidden, setHidden] = useState(true);
    const [navigationEl, setNavigationEl] = useState(null);
    const [isNavDisplayed, setIsNavDisplayed] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const [compareStickyCarouselSwiper, setCompareStickyCarouselSwiper] = useState(null);
    const setSwiper = (swiper) => {
        setCompareStickyCarouselSwiper(swiper);
        setSwiperInstance(swiper);
    };
    useEffect(() => {
        if (compareStickyCarouselSwiper !== null) {
            compareStickyCarouselSwiper.update();
        }
    }, [comparisonProducts, compareStickyCarouselSwiper]);
    useEffect(() => {
        const navigation = document.querySelector(NAVIGATION_HORIZONTAL);
        setNavigationEl(navigation);
        // This needed because the navigation menu gets hidden after the page loads with a delay
        setTimeout(() => setShouldRender(true), DELAY.DELAY_100);
        return () => setSwiperInstance(null);
    }, []);
    const compareStickyCarouselConfig = {
        variant: CarouselVariant.PRODUCT_TILE_NORMAL,
        arrowsConfig: {
            color: SliderNavColor.BASE,
            variant: SliderNavVariant.CIRCLE,
        },
        showPagination: false,
        fullWidth: true,
        configurationOverrides: {
            preventClicks: true,
            slidesPerView: 'auto',
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            getSwiper: setSwiper,
            breakpoints: {
                [MIN_SCREEN_WIDTH_TABLET]: {
                    slidesPerView: 'auto',
                    spaceBetween: SLIDE_SPACING.TABLET,
                },
                [MIN_SCREEN_WIDTH_DESKTOP]: {
                    slidesPerView: SLIDES_AMOUNT_DESKTOP,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
                [MIN_SCREEN_WIDTH_DESKTOP_LARGE]: {
                    slidesPerView: SLIDES_AMOUNT_DESKTOP_LARGE,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
            },
        },
    };
    const compareSlide = useCallback((product) => (_jsx(Column, { gutter: false, grid: 4, desktop: 3, tablet: 4, tabletSmall: 4, children: _jsx(CompareStickyBarSlide, { product: product }) }, `${product.productCode}${product.colourId}`)), [comparisonProducts]);
    useScrollPosition(({ currPos }) => {
        if (navigationEl) {
            if (!isDesktop) {
                setIsNavDisplayed(!navigationEl.classList.contains(NAVIGATION_HORIZONTAL_COLLAPSE));
            }
            else {
                if (isNavDisplayed) {
                    setIsNavDisplayed(false);
                }
            }
        }
        setHidden(Math.abs(currPos.y) < COMPARE_STICKY_POSITION_DESKTOP);
    }, [navigationEl, isNavDisplayed, isDesktop]);
    if (!shouldRender) {
        return null;
    }
    return (_jsx(StickyBarCotopaxi, { isHidden: hidden, variant: StickyBarVariant.COMPARE, withNavBar: isNavDisplayed, children: _jsx(Container, { column: "content", children: _jsx(Carousel, Object.assign({}, compareStickyCarouselConfig, { children: comparisonProducts.map(compareSlide) })) }) }));
};
